var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"album"},_vm._l((_vm.files),function(item,idx){return _c('ImageCard',{key:idx,attrs:{"media":item,"width":item.width,"height":item.height,"src":item.thumbnail,"title":item.filename}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }